<template>
  <BaseLayoutApp>
    <div class="discount" v-if="!loading">
      <div class="header">
        <div class="page-title">{{ discount.details.codeDiscount.title }}</div>
        <div class="page-subtitle">{{ discount.details.codeDiscount.shortSummary || discount.details.codeDiscount.summary }}</div>
      </div>
      <BaseLayoutCards>
        <BaseCard>
          <template #header>Status</template>
          <BaseForm :values="{ active: discount.active }" :submit="updateItem" #default="{ submittable, loading, newValues }">
            <div class="text">Make this discount appear in the widget</div>
            <FormulateInput :outer-class="['input']" type="toggle" name="active" :label="newValues.active ? 'On' : 'Off'" />
            <BaseButton text="Save" :loading="loading" :theme="submittable ? 'purple' : 'disabled'" />
          </BaseForm>
        </BaseCard>
        <BaseCard>
          <template #header>Delete</template>
          <BaseForm :values="{ checked: false }" :submit="deleteItem" #default="{ submittable, loading }">
            <FormulateInput :outer-class="['input']" type="checkbox" name="checked" label="Remove this discount from Confetti entirely" />
            <BaseButton text="Delete" :loading="loading" :theme="submittable ? 'red' : 'disabled'" />
          </BaseForm>
        </BaseCard>
      </BaseLayoutCards>
    </div>
    <BaseContentLoader v-else />
  </BaseLayoutApp>
</template>

<script>
import BaseLayoutCards from '@/components/BaseLayoutCards/BaseLayoutCards'
import BaseLayoutApp from '@/components/BaseLayoutApp/BaseLayoutApp'
import BaseContentLoader from '@/components/BaseContentLoader/BaseContentLoader'
import BaseCard from '@/components/BaseCard/BaseCard'
import BaseForm from '@/components/BaseForm/BaseForm'
import BaseButton from '@/components/BaseButton/BaseButton'
import discountService from '@/services/api/services/discountService'
export default {
  components: {
    BaseLayoutCards,
    BaseLayoutApp,
    BaseContentLoader,
    BaseCard,
    BaseForm,
    BaseButton
  },
  props: {
    id: {
      type: String,
      required: false
    }
  },
  async created() {
    this.loading = true
    this.discount = await discountService.findOneById(this.id)
    this.loading = false
  },
  data: () => ({
    discount: null,
    loading: true
  }),
  methods: {
    async updateItem(data) {
      this.discount = await discountService.updateOneById(this.id, data)
    },
    async deleteItem() {
      await discountService.deleteOneById(this.id)
      this.$router.push('/discounts')
    }
  }
}
</script>

<style lang="scss" scoped>
.discount {
  width: 100%;
  display: grid;
  grid-auto-flow: row;
  grid-gap: var(--spacing-5);
}
.header {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}
.page-title {
  font-size: var(--fs-title);
  font-weight: var(--fw-medium);
  margin-bottom: var(--spacing-1);
}
.page-subtitle {
  color: var(--color-gray-3);
}
.text {
  margin-bottom: var(--spacing-4);
  color: var(--color-gray-3);
}
.input {
  margin-bottom: var(--spacing-4);
}
</style>
